import { useQuery } from '@tanstack/react-query';
import { glacierPolicyApiGetAgentAuthorityOptions } from '../heyapi/@tanstack/react-query.gen';
import { useEffect, useState } from 'react';
import type { AgentAuthorityResponse } from '../heyapi';

export const useAgentAuthority = ({ policyId }: { policyId: string }) => {
  const [agentAuthority, setAgentAuthority] = useState<
    AgentAuthorityResponse | undefined
  >(undefined);

  const { data: agentAuthorityData, refetch: refetchAgentAuthority } = useQuery(
    {
      enabled: policyId !== undefined,
      ...glacierPolicyApiGetAgentAuthorityOptions({
        path: {
          account_id: policyId,
        },
      }),
    }
  );

  useEffect(() => {
    if (agentAuthorityData) {
      setAgentAuthority(agentAuthorityData);
    }
  }, [agentAuthorityData]);

  return {
    agentAuthority,
    refetchAgentAuthority,
  };
};
